import React from 'react';
import { FaChevronRight } from 'react-icons/fa';
import { useDispatch } from 'react-redux';

const PageNavigation = ({ pageable, onNextPageClickAction, onPrevPageClickAction }) => {
  const dispatch = useDispatch();

  const handleNextPageClick = () => {
    if (!pageable.last) {
      dispatch(onNextPageClickAction());
    }
  };

  const handlePrevPageClick = () => {
    if (!pageable.first) {
      dispatch(onPrevPageClickAction());
    }
  };

  return (
    <div className="flex justify-end items-center">
      <div className="flex md:text-sm text-xs mr-3">
        Сторінка:
        <span className="mx-1.5">{pageable.number + 1}</span>з
        <span className="ml-1.5">{Math.max(pageable.totalPages, 1)}</span>
      </div>
      <ul className="inline-flex -space-x-px text-xs">
        <li>
          <button
            disabled={pageable.first}
            onClick={handlePrevPageClick}
            className="w-10 sm:w-12 flex items-center justify-center py-2 md:p-4
                        border border-gray-300 duration-300 hover:bg-gray-100"
          >
            <FaChevronRight className="rotate-180" />
          </button>
        </li>
        <li>
          <button
            disabled={pageable.last}
            onClick={handleNextPageClick}
            className="w-10 sm:w-12 flex items-center justify-center py-2 md:p-4
                        border border-gray-300 duration-300 hover:bg-gray-100"
          >
            <FaChevronRight />
          </button>
        </li>
      </ul>
    </div>
  );
};

export default PageNavigation;
